module.exports = __webpack_public_path__ + "static/media/grains_0.cb9d83f4.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/grains/grains_0.csv
// module id = 728
// module chunks = 0